import { totalCommentsReceivedConfig } from '@/lib/analytics/kpis/tiktok/totalComments';
import { SIZE_50 } from '@/lib/gridElements/size';
import { MediaViewerKpiLoader } from '@/components/base/Kpi/KpiLoader';

export const mediaViewerCommentsConfig = {
    ...totalCommentsReceivedConfig,
    size: SIZE_50,
    name: 'kpi.linkedin.mediaviewer.comments',
    tooltip: null,
    loader: MediaViewerKpiLoader,
    mergedData: true
};
